module.exports = __webpack_public_path__ + "img/taiwan.a4d5ae43.jpg";